export default {
  lastUpdated: 'Last updated: {date}',

  layout: {
    label: 'Legal',
    toc: 'On this page',
    nav: {
      ariaLabel: 'Legal pages',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
      cookies: 'Cookie Policy',
    },
  },

  privacy: {
    title: 'Privacy Policy',
    intro: 'This Privacy Policy describes how KeyzoStore collects, uses, and protects your personal data when you use keyzostore.store.',
    sections: {
      dataWeCollect: {
        title: '1. Data we collect',
        items: [
          'Account data: email, password (hashed), optional profile fields.',
          'Order data: products purchased, prices, key delivery records.',
          'Payment data: handled by our payment provider — we never see your card details.',
          'Technical data: IP address, browser/user-agent (for security & rate-limiting).',
        ],
      },
      howWeUseIt: {
        title: '2. How we use it',
        items: [
          'To fulfill your orders and deliver keys.',
          'To prevent fraud and enforce our Terms.',
          'To send transactional emails (verification, receipts, password reset).',
        ],
      },
      sharing: {
        title: '3. Sharing',
        body: 'We share only what\'s necessary: order details with our key supplier (Kinguin), payment data with our payment provider. We do not sell your data.',
      },
      retention: {
        title: '4. Retention',
        body: 'Account data is kept for as long as your account exists. Order records may be retained longer for tax and accounting purposes.',
      },
      yourRights: {
        title: '5. Your rights',
        body: 'Under GDPR you can request access, correction, or deletion of your personal data. Contact support to exercise these rights.',
      },
      cookies: {
        title: '6. Cookies',
        body: 'See our [Cookie Policy](/legal/cookies) for details on cookies and tracking.',
      },
    },
    fallbackNote: 'Placeholder content. Final legal copy pending review.',
  },

  terms: {
    title: 'Terms & Conditions',
    intro: 'These Terms & Conditions govern your use of KeyzoStore (keyzostore.store). By creating an account or making a purchase, you agree to be bound by these terms.',
    sections: {
      service: {
        title: '1. Service',
        body: 'KeyzoStore is a marketplace that resells digital game keys sourced from third-party suppliers. Keys are delivered electronically — there is no physical fulfillment.',
      },
      eligibility: {
        title: '2. Eligibility',
        body: 'You must be at least 16 years old (or the age of majority in your jurisdiction) to use the service.',
      },
      purchaseDelivery: {
        title: '3. Purchase & Delivery',
        body: 'Orders are subject to availability and supplier limits. Keys are stored in your account for 24 hours after delivery; please redeem promptly.',
      },
      refunds: {
        title: '4. Refunds',
        body: 'Refund policy follows applicable consumer law. Once a key is revealed, refunds are generally not available.',
      },
      accountSecurity: {
        title: '5. Account & Security',
        body: 'You are responsible for keeping your password secure. Notify us immediately of any unauthorized access.',
      },
      liability: {
        title: '6. Limitation of Liability',
        body: 'To the maximum extent permitted by law, KeyzoStore is not liable for indirect, incidental, or consequential damages.',
      },
      changes: {
        title: '7. Changes',
        body: 'We may update these terms. Material changes will be notified by email or in-app.',
      },
      contact: {
        title: '8. Contact',
        body: 'Questions about these terms? Visit our FAQ or contact support.',
      },
    },
    fallbackNote: 'Placeholder content. Final legal copy pending review.',
  },

  cookies: {
    title: 'Cookie Policy & Settings',
    intro: 'We use cookies and similar technologies to keep the site working, understand usage, and (with your consent) tailor marketing.',

    cookiesWeUse: {
      title: 'Cookies we use',
    },

    groups: {
      essential: {
        title: 'Essential',
        tag: 'Always on',
        blurb: 'Required for the site to work — sign-in, session continuity and request security. These cannot be turned off.',
        cookies: [
          {
            purpose: 'Holds your short-lived access token so you stay authenticated across API and real-time (WebSocket) requests. HttpOnly.',
            expiry: '15 minutes',
          },
          {
            purpose: 'Securely renews your access token so your session persists without logging in again. HttpOnly.',
            expiry: '30 days',
          },
          {
            purpose: 'Set by Cloudflare on the Kinguin catalog API we call, to distinguish trusted traffic for rate-limiting and security. Not used for advertising or cross-site tracking.',
            expiry: 'Session (cleared when the browser closes)',
          },
        ],
      },
      analytics: {
        title: 'Analytics',
        tag: 'With your consent',
        blurb: 'Help us understand usage — page views, errors and health checks (e.g. Hotjar). Set only if you allow Analytics below.',
      },
      marketing: {
        title: 'Marketing',
        tag: 'With your consent',
        blurb: 'Used to measure campaigns and personalise advertising (e.g. Google, Meta). Set only if you allow Marketing below.',
      },
    },

    table: {
      cookie: 'Cookie',
      provider: 'Provider / source',
      purpose: 'Purpose',
      type: 'Type',
      expiry: 'Expiry',
      noCookies: 'No cookies in this category are set yet.',
    },

    cookieTypes: {
      Session: 'Session',
      Persistent: 'Persistent',
    },

    preferences: {
      title: 'Your preferences',
      essential: {
        label: 'Essential',
        description: 'Required for the site to work.',
      },
      analytics: {
        label: 'Analytics',
        description: 'Help us understand how the site is used.',
      },
      marketing: {
        label: 'Marketing',
        description: 'Used for personalized advertising.',
      },
      saved: 'Preferences saved.',
      lastSaved: 'Last saved: {date}',
      notSaved: 'No preferences saved yet.',
      saveButton: 'Save preferences',
      storageNote: 'Preferences are stored in your browser\'s local storage under {code} — clearing site data will reset them.',
    },

    fallbackNote: 'This inventory is reviewed as our integrations change. If anything looks out of date, contact support.',
  },
};
